"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keys = require("babel-runtime/core-js/object/keys");

var _keys2 = _interopRequireDefault(_keys);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _constants = require("../../utils/constants");

var _constants2 = _interopRequireDefault(_constants);

var _moment = require("moment");

var _moment2 = _interopRequireDefault(_moment);

var _env = require("../../utils/env");

var _env2 = _interopRequireDefault(_env);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BusinessesController = function () {
  function BusinessesController(BusinessesService, FilterService, AuthService, $scope) {
    "ngInject";

    (0, _classCallCheck3.default)(this, BusinessesController);
    this.businessesService = BusinessesService;
    this.filterService = FilterService;
    this.authService = AuthService;
    this.$scope = $scope;
    this.gridOptions = this.getGridOptions();
  }

  (0, _createClass3.default)(BusinessesController, [{
    key: "$onInit",
    value: function $onInit() {
      var dataSource = [];
      (0, _keys2.default)(_constants2.default.locationStatus).forEach(function (key) {
        var value = _constants2.default.locationStatus[key];
        if (value === 0) return;

        dataSource.push({
          value: value,
          text: _constants2.default.getLocationStatusText(value)
        });
      });
      this.businessStatusOptions = {
        dataSource: dataSource,
        dataTextField: "text",
        dataValueField: "value"
      };
    }
  }, {
    key: "getGridOptions",
    value: function getGridOptions() {
      var _this = this;

      return {
        dataSource: this.businessesService.getDataSource(this.dataSourceFetchSuccessCallback.bind(this), this.dataSourceErrorSuccessCallback.bind(this)),
        sortable: true,
        pageable: true,
        resizable: true,
        height: "90vh",
        noRecords: {
          template: "No match found. Change your filter criteria."
        },
        columns: [{ field: "id", title: "ID", filterable: false, width: "3rem" }, {
          field: "name", title: "Name", filterable: false, attributes: { "class": "col-name" }, width: "6rem",
          template: function template(dataItem) {
            return "<a class=\"cell\" href=\"/businesses/" + dataItem.id + "\"><span>" + dataItem.name + "</span></a>";
          }
        }, {
          field: "name", title: "Landing Page", filterable: false, attributes: { "class": "col-name" }, width: "4rem",
          template: function template(dataItem) {
            return "<a target=\"_blank\" class=\"cell\" href=\"https://www.jugglestreet.com.au/business-details?businessId=" + dataItem.id + "\"><span>Search results</span></a>";
          }
        },
        // {
        //   field: "jugglerId", title: "Name", filterable: false, attributes: {"class": "col-name"}, width: "12rem",
        //   template: (dataItem) => `<a class="cell" href="/users/${dataItem.userId}"><div class="image-container"><img src="${dataItem.imageUrl ? this.imageBaseUrl + dataItem.imageUrl : "/images/user-image-unavailable.png"}"></img></div><span>${dataItem.fullName}</span></a>`,
        // },
        // {
        //   field: "email", title: "Email", filterable: false, width: "15rem",
        //   template: `<a href="mailto:#= email #">#= email #</a>`
        // },
        // { field: "address", title: "Address", filterable: false, width: "8rem" },
        { field: "locationType", title: "Type", filterable: false, sortable: false, width: "4rem", template: function template(dataItem) {
            return "" + _this._getBusinessType(dataItem.locationType);
          } }, { field: "helpersCount", title: "Helpers Count", filterable: false, width: "2rem" }, { field: "locationStatus", title: "Lead Status", filterable: false, sortable: false, width: "4rem", template: function template(dataItem) {
            return "" + _this._getBusinessStatus(dataItem.locationStatus);
          } },
        // { field: "addressState", title: "State", filterable: false, width: "8rem" },
        // { field: "addressPostCode", title: "Postcode", filterable: false, width: "8rem" },
        // {
        //   field: "updatedAt", title: "Updated At", filterable: false, width: "6rem",
        //   template: `<span>#= kendo.toString(new Date(updatedAt ? updatedAt : createdAt), 'dd/MM @hh:mmtt') #</span>`,
        // },
        { title: "Update Status", command: [{ name: "edit", text: "Update" }], width: "4rem" }],
        editable: {
          mode: "popup",
          window: { title: "Update Business" },
          template: kendo.template($("#popup-editor").html())
        }
      };
    }
  }, {
    key: "saveChanges",
    value: function saveChanges(e) {
      // const check = e.model;

      // if ((check.visaCheckStatus == 2) && (!check.visaClass || !check.visaSubclass || !check.visaGrantDate || !check.visaExpiry)) {
      //   this.notificationService.error("Check missing fields and try again.");
      //   e.preventDefault();
      // }
    }
  }, {
    key: "applyFilters",
    value: function applyFilters() {
      this.gridOptions.dataSource.filter(this.filterService.getAppliedFilters());
    }
  }, {
    key: "dataSourceFetchSuccessCallback",
    value: function dataSourceFetchSuccessCallback(e) {
      this.businessesMatchCount = this.gridOptions.dataSource.total();
      this.$scope.$apply();
    }
  }, {
    key: "dataSourceErrorSuccessCallback",
    value: function dataSourceErrorSuccessCallback(e) {
      var _this2 = this;

      if (e.xhr.status == 401) {
        this.authService.refreshToken().then(function (response) {
          _this2.applyFilters();
        }).catch(function (error) {
          _this2.authService.logout();
        });
      } else {
        this.authService.logout();
      }
    }
  }, {
    key: "_getBusinessStatus",
    value: function _getBusinessStatus(status) {
      return _constants2.default.getLocationStatusText(status);
    }
  }, {
    key: "_getBusinessType",
    value: function _getBusinessType(type) {
      return _constants2.default.getLocationTypeText(type);
    }
  }]);
  return BusinessesController;
}();

exports.default = BusinessesController;


/** WEBPACK FOOTER **
 ** ./client/app/containers/businesses/businesses.controller.js
 **/